import ServiceBase from './ServiceBase';

export default class CurrenciesService extends ServiceBase {
    constructor($http) {
        super($http);
    }

    createCurrency(currency) {
        return this.request('post', 'siteadmin/currencies/createCurrency', currency);
    }

    searchCurrencies(filters, pageSize, pageIndex) {
        return this.request('post', 'siteadmin/currencies/searchCurrencies', {
            name: null,
            pageSize,
            pageIndex,
            ...filters,
        });
    }

    searchProjectCurrencies(filters, projectID, pageSize, pageIndex) {
        const params = {
            projectID,
            name: null,
            pageSize,
            pageIndex,
            ...filters,
        };

        return this.request('post', 'currencies/searchProjectCurrencies', params);
    }

    updateCurrency(currency) {
        return this.request('post', 'siteadmin/currencies/updateCurrency', currency);

    }
    updateProjectCurrency(currency) {
        return this.request('post', 'currencies/updateProjectCurrency', currency);
    }
}